module.exports = __webpack_public_path__ + "img/500c1180a96859e5c54a5359f024a397.500c1180.svg";